import React, { Component } from 'react';
import { RequestList } from './RequestList';
import { RtiDtl } from './RtiDtl';
import { HeaderSub2 } from '../../Common/HeaderSub2'
import { HeaderSub } from '../../Common/HeaderSub'
import { Footer } from '../../Common/Footer'
import { Big3Common } from '../../../js/IncludeManager'
/* 개발담당:양유빈
 * 화면기능:거래요청 메인
 * 세부설명:
*/

export class Index extends Component {
    static displayName = Index.name;
    constructor(props) {
        super(props);
        this.state = {
            RenderName: this.CompName.RequestList,  //기본 컴포넌트 할당
        };
    }
    CompName = {
        "RequestList": "RequestList",
        "RtiDtl": "RtiDtl" 
    }
    //초기화
    componentDidMount() {
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    }
    renderPick() {
        if (this.state.RenderName === this.CompName.RequestList) {
           
            return (
                <div>
                    <HeaderSub2
                        HeaderTitle="거래처"
                        HistoryBack={true}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <RequestList
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                    <Footer
                        fillName="icon1"
                        ComponentName={this.state.RenderName}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.RtiDtl) {
            return (
                <div>
                    <HeaderSub
                        ComponentUrl="RequestList"
                        HeaderTitle="거래처 정보"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <RtiDtl
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        
    }  
    render() {
        let RnderAct = this.renderPick();
        return (
            <div>
                {RnderAct}
            </div>
        );
    }
}
